import templateOnly from '@ember/component/template-only';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\'loading-placeholder\'>\n  <div class=\'cu-mind__wave\'>\n    <div class=\'cu-mind__wave-icon\'></div>\n    <img\n      class=\'cu-mind__wave-animation\'\n      src=\'https://beebeeassets.beebeeboard.com/assets/img/blu-wave-v1.gif\'\n      alt=\'wave\'\n      width=\'240\'\n      height=\'240\'\n    />\n  </div>\n</div>");

var bbMascotLoader = setComponentTemplate(TEMPLATE, templateOnly());

export { bbMascotLoader as default };
//# sourceMappingURL=bb-mascot-loader.js.map
